import ProjectFeesContainer from "./ProjectFeesContainer";

export default ProjectFeesContainer;
